import React, { Component } from 'react'
import './styles.scss'
import PropTypes from 'prop-types'
import { uploadItemStatus } from './constants'
import Loader from '../../../Shared/Loader'

class UploadItem extends Component {

  render () {
    switch (this.props.image.status) {
      case uploadItemStatus.uploading:
        if (this.props.image.progress === 100) {
          return (
            <div className="Imagebrowseritem Imagebrowseritem-Preview">
              <div className="Imagebrowseritem-Image-Container">
                <img
                  className={'Imagebrowseritem-Image Imagebrowseritem-Blured'}
                  src={this.props.image.src}
                  alt="Processing upload"
                />
                <div className="Imagebrowseritem-Content">
                  <div style={{ margin: 'auto auto' }}>Waiting to display image.</div>
                  <Loader size={32}/></div>
              </div>
              <div className="Imagebrowseritem-Toolbar"/>
            </div>
          )
        }
        return (
          <div className="Imagebrowseritem Imagebrowseritem-Preview">
            <div className="Imagebrowseritem-Image-Container">
              <img
                className={'Imagebrowseritem-Image Imagebrowseritem-Blured'}
                src={this.props.image.src}
                alt="Uploading"
              />
              <div className="Imagebrowseritem-Content">
                <div className="progress">
                  <div>{this.props.image.progress}%</div>
                  <Loader size={32}/></div>
              </div>
            </div>
            <div className="Imagebrowseritem-Toolbar">
              {/* eslint-disable-next-line*/}
              <a className="cancel" onClick={() => {this.props.image.cancel(this.props.image)}}>Cancel Upload</a>
            </div>
          </div>
        )
      case uploadItemStatus.waiting:
        return (
          <div className="Imagebrowseritem Imagebrowseritem-Preview">
            <div className="Imagebrowseritem-Image-Container">
              <div className="Imagebrowseritem-Content">
                <div style={{ margin: 'auto auto' }}>Image in queue</div>
              </div>
            </div>
            <div className="Imagebrowseritem-Toolbar"/>
          </div>
        )
      case uploadItemStatus.errorProcessImage:
        return (
          <div className="Imagebrowseritem Imagebrowseritem-Preview">
            <div className="Imagebrowseritem-Image-Container">
              <div className="Imagebrowseritem-Content">
                <div className={'error'}>
                  <div className="error-text">
                    File {this.props.image.name} could not be processed. We
                    recommend jpg files only.
                  </div>
                  <div className="error-confirm-button">
                    <span onClick={() => this.props.onRemove(this.props.image)}>Got it!</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="Imagebrowseritem-Toolbar"/>
          </div>
        )
      case uploadItemStatus.errorImageAlreadyExists:
        return (
          <div className="Imagebrowseritem Imagebrowseritem-Preview">
            <div className="Imagebrowseritem-Image-Container">
              <div className="Imagebrowseritem-Content">
                <div className={'error'}>
                  <div className="error-text">
                    Image {this.props.image.name} is already in the gallery.
                  </div>
                  <div className="error-confirm-button">
                    <span onClick={() => this.props.onRemove(this.props.image)}>Got it!</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="Imagebrowseritem-Toolbar"/>
          </div>
        )
      case uploadItemStatus.error:
        return (
          <div className="Imagebrowseritem Imagebrowseritem-Preview">
            <div className="Imagebrowseritem-Image-Container">
              <div className="Imagebrowseritem-Content">
                <div className={'error'}>
                  <div className="error-text">
                    File {this.props.image.name} could not be processed.
                  </div>
                  <div className="error-confirm-button">
                    <span onClick={() => this.props.onRemove(this.props.image)}>Got it!</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="Imagebrowseritem-Toolbar"/>
          </div>
        )
      default:
        return null
    }
  }
}

UploadItem.propTypes = {
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    status: PropTypes.number.isRequired,
    process: PropTypes.number,
    cancel: PropTypes.func
  }).isRequired,
  onRemove: PropTypes.func.isRequired
}

export default UploadItem
